import styled from "@emotion/styled";
import { TextField } from "@mui/material";

export const QuantityFieldWrapper = styled.div({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	p: {
		margin: "0 0 4px"
	},
	paddingBottom: "8px"
});

export const QuantityFieldButtons = styled.div({
	display: "flex",
	alignItems: "center"
});

export const QuantityFieldInput = styled(TextField)({
	height: "40px",
	width: "80px"
});
